import { Box, HStack } from '@chakra-ui/react';
import { useIsMobile } from '../../hooks/useIsMobile'

export function StickyActionFooter({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile()
  if (!isMobile) return null
  return (
    <Box
      position="fixed"
      left={0}
      right={0}
      bottom="calc(64px + env(safe-area-inset-bottom, 0px))"
      bg="surface"
      borderTop="1px"
      borderColor="gray.200"
      px={4}
      py={3}
      zIndex={9}
    >
      <HStack gap={3} css={{
        '& > *': { flex: 1 }
      }}>
        {children}
      </HStack>
    </Box>
  );
}
